import { render, staticRenderFns } from "./AnchorOrderItemComponent.vue?vue&type=template&id=00219e28&scoped=true&"
import script from "./AnchorOrderItemComponent.vue?vue&type=script&lang=js&"
export * from "./AnchorOrderItemComponent.vue?vue&type=script&lang=js&"
import style0 from "./AnchorOrderItemComponent.vue?vue&type=style&index=0&id=00219e28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00219e28",
  null
  
)

export default component.exports